import React, { useEffect, useState } from "react";

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="text-[11px] eyebrow text-exodus-muted">{label}</span>
    <div className="mt-2">{children}</div>
    {hint && <span className="block text-[11px] text-exodus-muted mt-1.5 leading-relaxed">{hint}</span>}
  </label>
);

export const Num = ({ testid, label, hint, value, onChange, step = 1, min, max, prefix, suffix }) => {
  const [txt, setTxt] = useState(Number.isFinite(value) ? String(value) : "");
  useEffect(() => { if (Number(txt) !== value) setTxt(Number.isFinite(value) ? String(value) : ""); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const edit = (s) => { setTxt(s); if (s.trim() !== "" && Number.isFinite(Number(s))) onChange(Number(s)); };
  return (
    <Field label={label} hint={hint}>
      <div className="flex items-center border border-exodus-border bg-exodus-bg focus-within:border-exodus-gold transition-colors">
        {prefix && <span className="pl-3 text-exodus-muted text-sm">{prefix}</span>}
        <input data-testid={testid} type="number" inputMode="decimal" step={step} min={min} max={max} value={txt}
          onChange={(e) => edit(e.target.value)} onBlur={() => { if (txt.trim() === "") { setTxt("0"); onChange(0); } }}
          className="w-full bg-transparent px-3 py-3 text-sm outline-none font-mono" />
        {suffix && <span className="pr-3 text-exodus-muted text-sm">{suffix}</span>}
      </div>
    </Field>
  );
};

export const Seg = ({ testid, label, hint, value, onChange, options, cols }) => (
  <Field label={label} hint={hint}>
    <div className={`grid gap-px bg-exodus-border border border-exodus-border ${cols || (options.length > 3 ? "grid-cols-2 sm:grid-cols-3" : ["", "grid-cols-1", "grid-cols-2", "grid-cols-3"][options.length])}`}>
      {options.map((o) => (
        <button key={String(o.v)} type="button" data-testid={`${testid}-${o.v}`} onClick={() => onChange(o.v)}
          className={`px-3 py-3 text-left text-sm transition-colors ${value === o.v ? "bg-exodus-gold text-exodus-bg" : "bg-exodus-surface hover:bg-exodus-elevated"}`}>
          <span className="block">{o.label}</span>
          {o.sub && <span className={`block text-[11px] mt-0.5 ${value === o.v ? "text-exodus-bg/70" : "text-exodus-muted"}`}>{o.sub}</span>}
        </button>
      ))}
    </div>
  </Field>
);

export const Toggle = ({ testid, label, hint, value, onChange }) => (
  <button type="button" data-testid={testid} onClick={() => onChange(!value)}
    className="w-full flex items-start justify-between gap-4 border border-exodus-border bg-exodus-surface px-4 py-3 text-left hover:border-exodus-gold transition-colors">
    <span>
      <span className="block text-sm">{label}</span>
      {hint && <span className="block text-[11px] text-exodus-muted mt-1">{hint}</span>}
    </span>
    <span className={`mt-0.5 shrink-0 w-10 h-5 rounded-full relative transition-colors ${value ? "bg-exodus-gold" : "bg-exodus-border"}`}>
      <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-exodus-bg transition-transform ${value ? "translate-x-5" : "translate-x-0.5"}`} />
    </span>
  </button>
);

export const Section = ({ title, children, testid }) => (
  <div data-testid={testid} className="space-y-5">
    <p className="eyebrow gold-text">{title}</p>
    {children}
  </div>
);

export const money = (n) => (n == null || !Number.isFinite(n) ? "—" : `$${Math.round(n).toLocaleString()}`);
export const pct = (n, d = 2) => (n == null ? "—" : `${Number(n).toFixed(d)}%`);
